/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import ShowLeadPageMenu from 'domain/sales/lead/ShowLeadPageMenu';
import ConvertLeadBreadcrumbs from 'domain/sales/lead/Convert/Breadcrumbs';
import LeadEntityHeader from 'domain/sales/lead/LeadEntityHeader';
import { ACCOUNT_TYPE } from 'domain/sales/account/shared/input/AccountInput';
import ConvertLeadForm from 'domain/sales/lead/Convert/ConvertLeadForm';
import useConvertLeadService from 'domain/sales/lead/Convert/convertLeadService';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';
import { useAccountUrl } from 'domain/shared/account';
import { useLeadId } from 'domain/sales/lead/leadRouting';
import { useDateService, DATE_FORMAT } from 'framework/utils';
import { DAYS_TO_CLOSE } from 'domain/sales/opportunity/opportunityService';
import { transformChecklistData } from 'domain/sales/shared/checklist/OpportunityChecklist';

const ConvertLead = () => {
  const { convertLead, getConvertValidationSchema, getInitialData } = useConvertLeadService();
  const { getSingleEntityUrl: getAccountSingleEntityUrl } = useAccountUrl();
  const { getSingleEntityUrl: getOpportunitySingleEntityUrl } = useOpportunityUrl();
  const id = useLeadId();
  const { getCurrentDateTimeInUtc } = useDateService();
  const currentDate = getCurrentDateTimeInUtc();
  const initialCloseDate = currentDate.add(DAYS_TO_CLOSE, 'days').format(DATE_FORMAT.INPUT_VALUE);

  const getDataMethod = async () => {
    const { companyName, firstName, middleName, lastName, title } = await getInitialData();

    return {
      firstName,
      middleName,
      lastName,
      title,
      originalAccountName: companyName,
      accountName: '',
      accountType: ACCOUNT_TYPE.NEW,
      opportunityName: companyName,
      closeDate: initialCloseDate,
    };
  };

  const getUrlForRedirectAfterSubmit = ({ opportunityId, accountId }: any) => {
    if (opportunityId) {
      return getOpportunitySingleEntityUrl(opportunityId);
    } else {
      return getAccountSingleEntityUrl(accountId);
    }
  };

  return (
    <CreateForm
      getDataFunc={getDataMethod}
      submitFormFunc={data => {
        const transformedData = { ...data };
        if (transformedData?.opportunityChecklist) {
          transformedData.opportunityChecklist = transformChecklistData(transformedData.opportunityChecklist);
        }
        return convertLead(id, transformedData);
      }}
      afterSubmit={{
        redirect: getUrlForRedirectAfterSubmit,
        message: 'You are awesome! The Lead has been successfully converted.',
      }}
      getValidationSchemaFunc={getConvertValidationSchema}
    >
      <CreatePageLayout
        title="Convert into:"
        menu={<ShowLeadPageMenu />}
        breadcrumbs={<ConvertLeadBreadcrumbs />}
        entityHeader={<LeadEntityHeader />}
      >
        <ConvertLeadForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default ConvertLead;
